import * as z from 'zod';
import { DateTime } from 'luxon';

const isNotPastDate = (value: string) => {
  const parsed = DateTime.fromFormat(value, 'yyyy-MM-dd', { zone: 'utc' });
  if (!parsed.isValid) {
    return false;
  }
  return parsed.startOf('day') >= DateTime.utc().startOf('day');
};

export const ChangeDueDateFormSchema = z.object({
  due_date: z.string().min(1, 'Required').refine(isNotPastDate, { message: 'Past dates are not allowed' }),
  reason: z.string().min(1, { message: 'Required' }),
});

export type ChangeDueDateForm = z.infer<typeof ChangeDueDateFormSchema>;
